/* eslint-disable no-dupe-keys */
export default {
  magcard: {
    name: '磁卡',
    // 属性（一般与对象内容匹配）
    prop: {
      name: '卡名',
      number: '卡号',
      password: '密码',
      user: '用户',
      service_provider: '适用运营商',
      status: '状态',
      created_at: '创建时间',
      updated_at: '更新时间',
      swipe_times: '刷卡次数',
      last_swiped_time: '最近刷卡时间',
      orders_count: '订单数'
    },
    // Enum的属性
    statuses: {
      enabled: '可用',
      disabled: '不可用'
    },
    has_passwords: {
      true: '有密码',
      false: '免密'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询卡名/卡号',
      input_name: '标记卡片信息，如车牌、用户名、手机',
      input_number: '16位的卡号',
      input_password: '加密卡才需要输入'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息',
      magcard_swipe_records: '刷卡记录',
      orders: '订单'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      swipe_info: '刷卡信息'
    },
    tips: {
      user_type_limit: '子运营商只能为虚拟用户绑定磁卡'
    }
  }
}
